import { SAFEGUARDING_ITEM_ID } from '@lmc/common/types'
import { type Home, LogCategory, LogCategoryItem } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useHasSafeguardingEnabled = () => {
  const logCategoryItems = useSelector(
    (state: { global: { home: Home } }) => state.global.home.logCategoryItems
  )

  const safeguardingEnabled = logCategoryItems?.some(
    (category) => category === SAFEGUARDING_ITEM_ID
  )

  return safeguardingEnabled
}

export default useHasSafeguardingEnabled
